import fetch from '@/api/fetch'

export function getSimpleSpuReq({
  spuId,
  needSvc,
  token,
  vvshopReferee,
  channel,
  purchaseChannel,
  liveRoomId,
  liveSceneId
}) {
  return fetch({
    url: '/v4/product/firstScreen/getInfo.json',
    params: { spuId, needSvc, token, vvshopReferee, channel, purchaseChannel, liveRoomId, liveSceneId }
  })
}

export function getSimpleSkuReq({
  skuId,
  spuId,
  channel,
  token,
  calcForEstimated,
  vvshopReferee,
  purchaseChannel,
  liveRoomId,
  liveSceneId
}) {
  return fetch({
    url: '/v4/product/firstScreen/getDetail.json',
    params: { skuId, spuId, channel, token, calcForEstimated, vvshopReferee, purchaseChannel, liveRoomId, liveSceneId }
  })
}

export function getDetailSpuReq({ spuId, needSvc, token, channel, purchaseChannel, liveRoomId, liveSceneId }) {
  return fetch({
    url: '/v4/product/async/getInfo.json',
    params: { spuId, needSvc, token, channel, purchaseChannel, liveRoomId, liveSceneId }
  })
}

export function getDetailSkuReq({
  skuId,
  spuId,
  channel,
  model,
  token,
  purchaseChannel,
  liveRoomId,
  liveSceneId,
  province,
  city,
  area: district
}) {
  return fetch({
    url: '/v4/product/async/getDetail.json',
    params: { skuId, spuId, channel, model, token, purchaseChannel, liveRoomId, liveSceneId, province, city, district }
  })
}

export function getInstallmentReq({ skuId, skuName, salePrice }) {
  const bankchannel = sessionStorage.getItem('bankchannel')
  return fetch({
    url: '/v4/product/async/getInstallmentDetail.json',
    params: bankchannel ? { bankchannel, skuId, skuName, salePrice } : { skuId, skuName, salePrice }
  })
}

export function getInstallmentInfo({ skuId, skuName, salePrice }) {
  const bankchannel = sessionStorage.getItem('bankchannel')
  return fetch({
    url: '/v4/product/async/getInstallmentInfo.json',
    params: bankchannel ? { bankchannel, skuId, skuName, salePrice } : { skuId, skuName, salePrice }
  })
}

/**
 * 获取商品支持的积分信息
 */
export function getPointInfoReq(params) {
  return fetch({
    url: '/product/getPointsDataDetail.json',
    params
  })
}

/**
 * 获取优惠券信息
 * @param {Object} params - 包含spuId、skuId属性.
 */
export function getUserCoupon(params) {
  return fetch({
    url: '/v4/product/getUserCoupon',
    params
  })
}

/**
 * 根据spuId、fullpaySkuIdSet评价信息
 * @param {Object} params - 包含spuId属性,fullpaySkuIdSet属性.
 */
export function getRemark(params) {
  return fetch({
    url: '/v1/product/latest/remark',
    params
  })
}

/**
 * 根据spuId、fullpaySkuIdSet、onlyHasPicture、pageNum、pageSize获取评价信息
 * @param {Object} params - 包含spuId属性,fullpaySkuIdSet属性.
 */
export function getRemarkList(params) {
  return fetch({
    url: '/v1/comment/query-list',
    params,
    showErrorPage: true
  })
}

/**
 * 获取商品问答
 */
export function getQuestionList(params) {
  return fetch({
    url: '/v1/qa/list',
    params
  })
}

/**
 * 根据spuId获取评测信息
 * @param {Object} params - 包含spuId属性.
 */
export function getCommodityPostList(params) {
  return fetch({
    url: '/v1/commodityEvaluation/getCommodityPostList',
    params,
    showErrorPage: true
  })
}

/**
 * 获取评测详情信息
 */
export function getCommodityDetail(params) {
  return fetch({
    url: '/v1/commodityEvaluation/getCommodityPostDetail',
    params,
    showErrorPage: true
  })
}

/**
 * 点赞
 */
export function giveLike(params) {
  return fetch({
    url: '/v1/comment/give-like',
    params
  })
}

/**
 * 为您推荐和热门推荐
 */
export function getRecommendReq(params) {
  return fetch({
    url: '/v4/product/getRecommend',
    params
  })
}

/**
 * @param {String} spuId
 * @param {Array} skuIds
 * AI推荐
 */
export function getAIRecommend(params) {
  return fetch({
    url: '/v4/product/getAIRecommend',
    params
  })
}

/**
 * 根据spuId获取已经收藏的skuid集合
 * @param {Object} params - 包含spuId属性.
 */
export function listMemberFavorite(params) {
  return fetch({
    url: '/v1/favorite/listMemberFavorite',
    unLogin: true,
    params
  })
}

/**
 * 收藏商品、取消收藏
 * isCollection: 判断是取消还是收藏
 */
export function collectionProduct(isCollection, params) {
  let url = isCollection ? '/my/favorite/add' : '/my/favorite/remove'
  return fetch({
    method: 'post',
    url,
    setCsrfToken: true,
    params
  })
}

/**
 * 拼团列表
 */
export function getGrouponList(params) {
  return fetch({
    url: '/groupon/getPlayingInfo',
    params
  })
}

// ------提交流程所有接口 start------

// 是否可卖
export function isActAllowSellReq(params) {
  return fetch({
    url: '/buy/isActAllowSell',
    params
  })
}

// 加入购物车
export function addCommodityReq(params) {
  return fetch({
    url: '/v2/shopcart/addCommodity',
    method: 'POST',
    setCsrfToken: true,
    data: params
  })
}

// 商品加入购物车获取奖励
export function getRewardResultReq() {
  return fetch({
    url: '/shopCart/getRewardResult',
    method: 'POST'
  })
}

// 商品是否可卖
// 套餐商品统一走isAllowedSell接口，来判断套餐中抢购活动（包括主商品和附属商品）状态的变更
export function isAllowedSellReq(params) {
  return fetch({
    url: '/buy/isAllowedSell',
    method: 'POST',
    data: params,
    useJsonType: true
  })
}

// 拼团
// 拼团之前的校验
export function isGroupAllowedSellReq({ skuId, promotionId, grouponId, num, suiteCode, channel }) {
  return fetch({
    url: '/groupon/isGrouponActAllowSell',
    params: {
      skuId,
      promotionId,
      grouponId,
      num,
      suiteCode,
      channel
    }
  })
}

// 自动领券接口couponUuids, longitude, latitude
export function autoReceiveCouponReq(params) {
  return fetch({
    url: '/coupon/autodirect',
    params
  })
}

// 会员优先购
// 会员优先购确定之前的校验
export function isVipAllowSell(params) {
  return fetch({
    url: '/buy/isVipAllowSell',
    params
  })
}

// ------提交流程所有接口 end------

// 现货购买
export function getEstimatedPrice({
  skuId,
  spuId,
  channel,
  token,
  calcForEstimated,
  vvshopReferee,
  purchaseChannel,
  liveRoomId,
  liveSceneId
}) {
  return fetch({
    url: '/v4/product/async/getEstimatedPrice',
    params: { skuId, spuId, channel, token, calcForEstimated, vvshopReferee, purchaseChannel, liveRoomId, liveSceneId }
  })
}

export function getPartCmmdyList(params) {
  return fetch({
    url: '/v4/product/getPartCmmdyList',
    params
  })
}

/**
 * 分享卡片接口
 * @param {Object} params
 */
export function shareContent(params) {
  return fetch({
    url: '/commodityPoster/shareContent',
    unLogin: true,
    params
  })
}

// 根据坐标或详细地址获取门店闪送信息
export function getStoreInfo(params) {
  return fetch({
    url: '/v4/product/O2O',
    params
  })
}

export function getRedirectMoyinUrlReq(skuId) {
  return fetch({
    url: `/order/quick/getRedirectMoyinUrl?skuId=${skuId}`
  })
}

/**
 * 地址列表
 */
export function getAddressListReq() {
  return fetch({
    url: '/my/address/list'
  })
}

/**
 * 获取加购推荐
 */
export function getAdditionRecommend(params) {
  return fetch({
    url: '/v4/product/getAdditionRecommend',
    params
  })
}
